import DrawingMenu from 'src/components/organisms/DrawingMenu/DrawingMenu'

export default DrawingMenu
